React = require 'react'
Action = require 'models/action'
ActionTemplate = require 'views/templates/action-react'
Auth = require 'db/auth'
Util = require 'lib/util'
Label = require 'models/label'
t = require('views/internal/recup-with-helpers')()
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'
CanonicalComment = require 'views/canonical-comment/canonical-comment-components'
{ BoardAndCommentContainer } = require '@atlassian/trello-canonical-components/canonical-card'

module.exports = class HomeActivityFeedActivityComponent extends React.Component
  displayName: 'HomeActivityFeedActivityComponent'

  constructor: (props) ->
    super props

    @state = {
      isReplying: false
      replyMessage: '@' + props.action.memberCreator?.get('username') + ' '
      hasReplied: false
      replyAction: null
    }

    @onReplyClick = @onReplyClick.bind(@)
    @onSaveClick = @onSaveClick.bind(@)
    @onCancelClick = @onCancelClick.bind(@)
    @onChangeReplyMessage = @onChangeReplyMessage.bind(@)

    @replyActionPromise = null

  componentWillUnmount: ->
    @replyActionPromise?.cancel()

  onReplyClick: ->
    @setState
      hasReplied: false
      replyAction: null
    , =>
      # Delaying the this setState will remount the reply container, skipping
      # the default animation.
      @setState (prevState) -> isReplying: !prevState.isReplying

  onCancelClick: ->
    @setState isReplying: false

  onChangeReplyMessage: (e) ->
    Util.preventDefault(e)
    @setState replyMessage: e.target.value

  onSaveClick: ->
    @replyActionPromise?.cancel()

    @replyActionPromise = @props.action.card.addComment(@state.replyMessage)
    @replyActionPromise.then (action) =>
      @setState(replyAction: action)

    @setState {
      replyMessage: '@' + @props.action.memberCreator?.get('username') + ' '
      hasReplied: true
      isReplying: false
    }

  render: t.renderable ->
    {
      action
      memberCreator
      trackOnClickCanonicalCard
    } = @props

    { isReplying, replyMessage, hasReplied, replyAction } = @state

    card = action.card
    board = card.getBoard()
    organization = board.getOrganization()
    canReply =
      board?.canComment(Auth.me()) &&
      (
        action.isAddAttachment ||
        (action.isCommentLike && action.memberCreator? && !Auth.isMe(action.memberCreator))
      )

    t.div '.home-activity', =>
      t.tag BoardAndCommentContainer, =>
        t.div '.home-activity-card', { onClick: => trackOnClickCanonicalCard() } , ->
          t.tag CanonicalCard, {
            board
            boardClassName: 'canonical-stretch'
            canRemove: false
            card
            cardClassName: 'canonical-stretch'
            labels: card.getLabels().sort(Label.compare)
            list: card.getList()
            members: card.memberList.models
            numNotifications: 0
            organization
            lightBackground: true
          }

        t.div =>
          t.tag CanonicalComment, {
            board
            comment: action.entity
            commentMemberCreator: action.memberCreator
            date: action.entity.date
            isEdited: action.entity.isEdited
            canReply
            isReplying
            hasReplied
            replyAction
            replyMessage
            memberCreator
            onChangeReplyMessage: @onChangeReplyMessage
            onReplyClick: @onReplyClick
            onCancelClick: @onCancelClick
            onSaveClick: @onSaveClick
          }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-activity-feed-activity-component.coffee